<template>
  <v-card fluid class="ma-4">
    <v-container>
      <v-text-field
        :value="from"
        label="From"
        readonly
        :loading="loading"
        hide-details
      ></v-text-field>
      <v-text-field
        :value="to"
        label="To"
        readonly
        :loading="loading"
        hide-details
      ></v-text-field>
      <v-text-field
        :value="subject"
        label="Subject"
        readonly
        :loading="loading"
        hide-details
        class="mb-5"
      ></v-text-field>
      <v-container v-html="content"></v-container>
    </v-container>
  </v-card>
</template>

<script>
  import { API } from '@/utils/api'

  export default {
    components: {},
    data: () => ({
      loading: false,
      from: null,
      to: null,
      subject: null,
      content: null,
    }),
    mounted () {
      this.loading = true
      API.call('/mail/item.json', {
        mail_id: this.$route.query.mail_id,
        login: this.$route.query.login,
        newsletter_id: this.$route.query.newsletter_id,
        content_id: this.$route.query.content_id,
      }, null, this.$store.state.auth.entities[0]).then(resp => {
        this.from = resp.data.from
        this.to = resp.data.to
        this.subject = resp.data.subject
        this.content = resp.data.content
      }).finally(() => {
        this.loading = false
      })
    }
  }
</script>
